import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement(React.Fragment, null, React.createElement("defs", null, React.createElement("style", null, ".maps_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), React.createElement("path", {
  className: "maps_svg__a",
  d: "M8.791 22.292a.5.5 0 0 1-.582 0l-6.5-4.642a.5.5 0 0 1-.209-.407V2.472a.5.5 0 0 1 .791-.407L8.5 6.5l6.709-4.792a.5.5 0 0 1 .582 0l6.5 4.642a.5.5 0 0 1 .209.407v14.771a.5.5 0 0 1-.791.407L15.5 17.5zM8.5 6.5v15.886M15.5 17.5V1.614"
}));

var SvgMaps = function SvgMaps() {
  return _ref;
};

export default SvgMaps;